import { FileSelectionHelper } from "@/Common/Helpers/FileSelectionHelper";
import { FileType } from "@/Common/Models/FileType";
import { ExportableFile, IExportableFile, IExportableFileLoaded } from "../ExportableFile";

interface IFileTypeDocumentBytes extends IExportableFile {
    DocumentBytesId: string;
}

class FileTypeDocumentBytes extends ExportableFile implements IFileTypeDocumentBytes {
    public DocumentBytesId: string;

    constructor(fields: IFileTypeDocumentBytes) {
        super(FileType.DOCUMENTBYTES);
        Object.assign(this, fields);
    }

    public getAttachedObject_ObjectId(): string { return this.DocumentBytesId; }

    public getCleanCopy(): FileTypeDocumentBytes {
        let copyConstructor: IFileTypeDocumentBytes = {
            DocumentBytesId: this.DocumentBytesId,
            date: this.date,
            description: this.description
        };

        return new FileTypeDocumentBytes(copyConstructor);
    }

    public async getMeta(): Promise<number> {
        throw "Not implemented";
    }

    protected generateFileIfNeeded(): Promise<IExportableFileLoaded> {
        const fetchUrl = FileSelectionHelper.getFetchUrl(this.DocumentBytesId, this.fileType, { noCache: true });

        return new Promise(resolve => resolve({
            OriginalExportableFile: this,
            FetchUrl: fetchUrl
        }));
    }
}

export { FileTypeDocumentBytes };
